import { Box } from "@mui/material"
import { registerTab, Tabs } from "lib/@components/tabs"
import { AddGroupSchedules } from "./add-group-schedules"
import { AddGroupTasks } from "./add-group-tasks"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { AddSchedulesButton } from "../../plugins/add-schedules-button"
import { References } from "../references"
import { ExtendedNoResults } from "../extended-no-results"
import { isGroupValid } from "../lib/is-group-valid"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function AddGroup() {
    const { hasAddedSchedules, group } = useBoundContext()
    const isValid = isGroupValid(group)
    registerTab({
        tab: "addgroup",
        id: "schedules",
        title: <Box>Schedules</Box>,
        content: <AddGroupSchedules />,
    })
    registerTab({
        tab: "addgroup",
        id: "tasks",
        title: <Box>Tasks</Box>,
        content: <AddGroupTasks />,
    })
    registerTab({
        tab: "addgroup",
        id: "references",
        title: <Box>References</Box>,
        content: <References />,
        tabProps: { disabled: !isValid },
    })
    return (
        <If truthy={!!hasAddedSchedules}>
            <Tabs id="addgroup" panelHolder={<Box my={2} />} tabHolder={<Box />} />
            <Else>
                <ExtendedNoResults
                    message="You don't have any schedules to add tasks to yet."
                    component={
                        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
                            <AddSchedulesButton variant="contained" />
                        </Secure>
                    }
                />
            </Else>
        </If>
    )
}
